import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HelpersService } from 'libs/shared/src/lib/services/helpers.service';

@Component({ standalone: false,
  selector: 'vfa-cp-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private helpersService: HelpersService) {
  }

  ngOnInit() {
    this.helpersService.login(true);
  }
}

